import ComponentBase from "../../ComponentBase";
import CLog, { LogTypes } from "../../ComponentLogger";
import SkinSwapEffect from "../../../Effects/SkinSwapEffect";

/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

 /** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class LabelAutoResizingComponent extends ComponentBase
{
    @property(cc.Label)
    protected label: cc.Label = null;

    @property(cc.Boolean)
    protected setWidth: boolean = true;

    @property(cc.Boolean)
    protected setHeight: boolean = false;

    @property(cc.Size)
    protected dampner: cc.Size = new cc.Size(1, 1);

    private _startingSize: cc.Size = null;
    private _startingScale: cc.Vec2 = null;
    private _startingLabelLength: number = 0;
    private _startingFontSize: cc.Size = null;

    private _lastLabelLength: number = 0;

    protected onLoad(): void
    {
        super.onLoad();

        if (!this.label)
        {
            this.enabled = false;
            CLog.warn('No label set.', LogTypes.Initialization, this);
            return;
        }

        this._startingSize = this.node.getContentSize();
        this._startingScale = new cc.Vec2(this.node.scaleX, this.node.scaleY);

        this._startingLabelLength = this.label.string.length;

        this._startingFontSize = new cc.Size(
            this.label.actualFontSize / (this.dampner.width || 1),
            this.label.actualFontSize / (this.dampner.height || 1)
        );

        this.label.node.on('size-changed', () => this.onSizeChanged());
    }

    private onSizeChanged(): void
    {
        const labelLength: number = this.getLabelLength();

        let changeCount: number = labelLength - this._startingLabelLength;
        if (labelLength === this._lastLabelLength) { return; }

        this.widthChangedHandler(changeCount);
        this.heightChangedHandler(changeCount);

        this._lastLabelLength = labelLength;
    }

    private widthChangedHandler(changeCount: number): void
    {
        if (!this.setWidth) { return; }

        let scale: number = (this._startingScale.x - this.node.scaleX) + 1;
        if (scale === 0) { return; }

        this.node.width = (this._startingSize.width / scale)
            + (changeCount * this._startingFontSize.width);
    }

    private heightChangedHandler(changeCount: number): void
    {
        if (!this.setHeight) { return; }

        let scale: number = (this._startingScale.y - this.node.scaleY) + 1;
        if (scale === 0) { return; }

        this.node.height = (this._startingSize.height / scale)
            + (changeCount * this._startingFontSize.height);
    }

    private getLabelLength(): number
    {
        if (!this.label || !this.label.string) { return 0; }
        return this.label.string.length;
    }
}
